var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 4L0 0h6z","fill":"currentColor","fillRule":"nonzero"}));
}

Triangle.defaultProps = {"width":"6","height":"4"};

module.exports = Triangle;

Triangle.default = Triangle;
